var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGoogleAds = function SvgGoogleAds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18a3 3 0 106 0 3 3 0 10-6 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M10.501 2.401A3 3 0 009.402 6.5l7.5 13a3 3 0 005.197-2.998l-7.5-13a3 3 0 00-4.098-1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12 11.003l-4.9 8.496a3 3 0 01-5.2-2.998L9.394 3.514"
  }))));
};
export default SvgGoogleAds;